import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CHOSEN_LANGUAGE, supportedLanguages } from './app.config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title: string = 'vertical-light';
  showSidebar: boolean = true;
  showNavbar: boolean = true;
  showFooter: boolean = true;
  showSettingsPanel: boolean = true;
  isLoading: boolean | undefined

  constructor(private router: Router,
              private translate: TranslateService) {
    translate.addLangs(supportedLanguages);
    let langToSet = localStorage.getItem(CHOSEN_LANGUAGE);
    if (!langToSet || langToSet === 'undefined' || langToSet === 'null' || !supportedLanguages.includes(langToSet)) {
      const browserLanguage = translate.getBrowserLang();
      if (browserLanguage && supportedLanguages.includes(browserLanguage)) {
        langToSet = browserLanguage;
      } else {
        langToSet = supportedLanguages[0];
      }
    }
    localStorage.setItem(CHOSEN_LANGUAGE, langToSet);
    translate.setDefaultLang(langToSet);
    translate.use(langToSet);

    // Removing Sidebar, Navbar, Footer for Documentation, Error and Auth pages
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        const cleanUrl = event.url.split('?')[0];

        if (cleanUrl === '/rtl') {
          //translate.use(ar)
          const body = document.querySelector('body');
          if (body) {
            body.classList.add('rtl');
            body.setAttribute('dir', 'rtl');
            this.swapMarginClasses();
          }
        } else {
          //translate.use(en)
          const body = document.querySelector('body');
          if (body) {
            body.classList.remove('rtl');
            body.setAttribute('dir', 'ltr');
            this.swapMarginClasses();
          }
        }

        if ((cleanUrl === '/user-pages/login') ||
          (cleanUrl === '/user-pages/register') ||
          (cleanUrl === '/user-pages/lock-screen') ||
          (cleanUrl === '/login') ||
          (cleanUrl === '/error-pages/404') ||
          (cleanUrl === '/error-pages/500')) {

          this.showSidebar = false;
          this.showNavbar = false;
          this.showFooter = false;
          this.showSettingsPanel = false;

          const mainPanel = document.querySelector('.main-panel');
          const pageBodyWrapper = document.querySelector('.page-body-wrapper');
          const contentWrapper = document.querySelector('.content-wrapper');

          if (mainPanel) {
            mainPanel.classList.add('w-100');
          }

          if (pageBodyWrapper) {
            pageBodyWrapper.classList.add('full-page-wrapper');
          }

          if (contentWrapper) {
            // JAVÍTÁS: Itt is a cleanUrl-t használjuk!
            if ((cleanUrl === '/login') || (cleanUrl === '/user-pages/login') || (cleanUrl === '/user-pages/register')) {
              contentWrapper.classList.add('auth', 'auth-img-bg');
            } else if (cleanUrl === '/user-pages/lock-screen') {
              contentWrapper.classList.add('auth', 'lock-full-bg');
            } else {
              contentWrapper.classList.remove('auth', 'auth-img-bg');
              contentWrapper.classList.remove('auth', 'lock-full-bg');
            }

            if ((cleanUrl === '/error-pages/404') || (cleanUrl === '/error-pages/500')) {
              contentWrapper.classList.add('p-0');
            }
          }
        } else {
          // Ha nem login vagy hibaoldal, akkor mindent megjelenítünk
          this.showSidebar = true;
          this.showNavbar = true;
          this.showFooter = true;
          this.showSettingsPanel = true;

          const mainPanel = document.querySelector('.main-panel');
          const pageBodyWrapper = document.querySelector('.page-body-wrapper');
          const contentWrapper = document.querySelector('.content-wrapper');

          if (mainPanel) {
            mainPanel.classList.remove('w-100');
          }

          if (pageBodyWrapper) {
            pageBodyWrapper.classList.remove('full-page-wrapper');
          }

          if (contentWrapper) {
            contentWrapper.classList.remove('auth', 'auth-img-bg');
            contentWrapper.classList.remove('p-0');
          }
        }
      }
    });

    // Spinner for lazyload modules
    router.events.forEach((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.isLoading = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.isLoading = false;
      }
    });
  }

  ngOnInit() {
    // Scroll to top after route change
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  // Method to swap margin and padding classes for RTL
  private swapMarginClasses(): void {
    const allElements = document.querySelectorAll('[class*="me-"], [class*="ms-"], [class*="pe-"], [class*="ps-"]');

    allElements.forEach((element: Element) => {
      const classes = element.className.split(' ');

      const newClasses = classes.map((className: string) => {
        // Swap me-* with ms-*
        if (className.match(/^me-/)) {
          return className.replace(/^me-/, 'ms-');
        } else if (className.match(/^ms-/)) {
          return className.replace(/^ms-/, 'me-');
        }
        // Swap pe-* with ps-*
        else if (className.match(/^pe-/)) {
          return className.replace(/^pe-/, 'ps-');
        } else if (className.match(/^ps-/)) {
          return className.replace(/^ps-/, 'pe-');
        }
        return className;
      });

      element.className = newClasses.join(' ');
    });
  }
}
